module.exports = __webpack_public_path__ + "img/image-21.321c555c.webp";